import { r as registerInstance, h, H as Host, g as getElement } from './index-6042f3c2.js';
import { s as showToast } from './toast-manager-2eb7cc10.js';
var ispuiToastCss = ".ispui-toast{position:relative;display:inline-block}";
var Toast = /** @class */ (function () {
    function Toast(hostRef) {
        registerInstance(this, hostRef);
        /**
         * Boolean flag for click event listener
         */
        this.listenClick = true;
        /** Z-index for toast popup */
        this.zIndex = '100';
    }
    /**
     * Show toast on click, if has listen-click prop
     */
    Toast.prototype.showPopupOnClick = function () {
        if (this.listenClick) {
            var toastContent = this.hostEl.querySelector('[slot]');
            if (!toastContent) {
                console.error('One must place slot = "content" to show toast');
                return;
            }
            showToast({
                toastContent: toastContent.innerHTML,
                anchorElement: this.hostEl,
                timeout: this.timeout,
                placement: this.placement,
                offsets: this.offsets,
                zIndex: this.zIndex,
                viewport: this.viewport,
                mountTarget: this.mountTarget,
            });
        }
    };
    Toast.prototype.render = function () {
        return (h(Host, { class: "ispui-toast" }, h("slot", null)));
    };
    Object.defineProperty(Toast.prototype, "hostEl", {
        get: function () { return getElement(this); },
        enumerable: false,
        configurable: true
    });
    return Toast;
}());
Toast.style = ispuiToastCss;
export { Toast as ispui_toast };
